// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blueanchor {
  cursor: pointer;
  text-decoration: underline;
  color: #3bb1ff;
}

:host ::ng-deep {
  /* Responsive */
}
:host ::ng-deep .p-paginator .p-paginator-current {
  margin-left: auto;
}
:host ::ng-deep .p-progressbar {
  height: 0.5rem;
  background-color: #D8DADC;
}
:host ::ng-deep .p-progressbar .p-progressbar-value {
  background-color: #607D8B;
}
:host ::ng-deep .table-header {
  display: flex;
  justify-content: space-between;
}
:host ::ng-deep .p-calendar .p-datepicker {
  min-width: 25rem;
}
:host ::ng-deep .p-calendar .p-datepicker td {
  font-weight: 400;
}
:host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-header {
  padding: 1rem;
  text-align: left;
  font-size: 1.5rem;
}
:host ::ng-deep .p-datatable.p-datatable-customers .p-paginator {
  padding: 1rem;
}
:host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-thead > tr > th {
  text-align: left;
}
:host ::ng-deep .p-datatable.p-datatable-customers .p-dropdown-label:not(.p-placeholder) {
  text-transform: uppercase;
}
:host ::ng-deep .p-datatable.p-datatable-customers:not(.p-datatable-gridlines) .p-datatable-tbody > tr > td {
  cursor: auto;
}
:host ::ng-deep .p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
.customer-badge.status-qualified {
  background: #C8E6C9;
  color: #256029;
}
.customer-badge.status-unqualified {
  background: #FFCDD2;
  color: #C63737;
}
.customer-badge.status-negotiation {
  background: #FEEDAF;
  color: #8A5340;
}
.customer-badge.status-new {
  background: #B3E5FC;
  color: #23547B;
}
.customer-badge.status-renewal {
  background: #ECCFFF;
  color: #694382;
}
.customer-badge.status-proposal {
  background: #FFD8B2;
  color: #805B36;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
.product-badge.status-instock {
  background: #C8E6C9;
  color: #256029;
}
.product-badge.status-outofstock {
  background: #FFCDD2;
  color: #C63737;
}
.product-badge.status-lowstock {
  background: #FEEDAF;
  color: #8A5340;
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
.order-badge.order-delivered {
  background: #C8E6C9;
  color: #256029;
}
.order-badge.order-cancelled {
  background: #FFCDD2;
  color: #C63737;
}
.order-badge.order-pending {
  background: #FEEDAF;
  color: #8A5340;
}
.order-badge.order-returned {
  background: #ECCFFF;
  color: #694382;
}

.buttonswrapper {
  display: flex;
  justify-content: space-between;
}

.mobilesearch {
  display: none;
}

.eurocodewidth {
  width: 11rem;
}

.oewidth {
  width: 7rem;
}

@media screen and (max-width: 960px) {
  .buttonswrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .mobilesearch {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
  }
  .mobilesearch .mobile-width-100 {
    width: 100%;
  }
  .mobilesearch .eurocodewidth {
    width: 100%;
  }
  .mobilesearch .oewidth {
    width: 100%;
  }
  :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-thead > tr > th,
  :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tfoot > tr > td {
    display: none !important;
  }
  :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr {
    border-bottom: 1px solid var(--surface-d);
  }
  :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td {
    text-align: left;
    display: block;
    border: 0 none !important;
    width: 100% !important;
    float: left;
    clear: left;
    border: 0 none;
  }
  :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
    padding: 0.4rem;
    min-width: 30%;
    display: inline-block;
    margin: -0.4rem 1rem -0.4rem -0.4rem;
    font-weight: bold;
  }
  :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td .p-progressbar {
    margin-top: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/argic/view/matrixsearch.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EAAe,0BAAA;EAA0B,cAAA;AAG7C;;AAAA;EAuDC,eAAA;AAnDD;AAFE;EACC,iBAAA;AAIH;AAAC;EACC,cAAA;EACA,yBAAA;AAEF;AAAE;EACC,yBAAA;AAEH;AAEC;EACC,aAAA;EACA,8BAAA;AAAF;AAGC;EACC,gBAAA;AADF;AAGE;EACC,gBAAA;AADH;AAME;EACC,aAAA;EACA,gBAAA;EACA,iBAAA;AAJH;AAOE;EACC,aAAA;AALH;AAQE;EACC,gBAAA;AANH;AASE;EACC,yBAAA;AAPH;AAYE;EACC,YAAA;AAVH;AAeC;EACC,aAAA;AAbF;;AAiBA;EACC,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AAdD;AAgBC;EACC,mBAAA;EACA,cAAA;AAdF;AAiBC;EACC,mBAAA;EACA,cAAA;AAfF;AAkBC;EACC,mBAAA;EACA,cAAA;AAhBF;AAmBC;EACC,mBAAA;EACA,cAAA;AAjBF;AAoBC;EACC,mBAAA;EACA,cAAA;AAlBF;AAqBC;EACC,mBAAA;EACA,cAAA;AAnBF;;AAuBA;EACC,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AApBD;AAsBC;EACC,mBAAA;EACA,cAAA;AApBF;AAuBC;EACC,mBAAA;EACA,cAAA;AArBF;AAwBC;EACC,mBAAA;EACA,cAAA;AAtBF;;AA0BA;EACC,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AAvBD;AAyBC;EACC,mBAAA;EACA,cAAA;AAvBF;AA0BC;EACC,mBAAA;EACA,cAAA;AAxBF;AA2BC;EACC,mBAAA;EACA,cAAA;AAzBF;AA4BC;EACC,mBAAA;EACA,cAAA;AA1BF;;AAoCA;EACC,aAAA;EACA,8BAAA;AAjCD;;AAoCA;EACC,aAAA;AAjCD;;AAoCA;EACC,YAAA;AAjCD;;AAoCA;EACC,WAAA;AAjCD;;AAoCA;EACC;IACC,aAAA;IACA,sBAAA;IACA,SAAA;EAjCA;EAmCD;IACC,aAAA;IACA,sBAAA;IACA,SAAA;IACA,mBAAA;EAjCA;EAkCA;IACC,WAAA;EAhCD;EAkCA;IACC,WAAA;EAhCD;EAmCA;IACC,WAAA;EAjCD;EA0CE;;IAEC,wBAAA;EAxCH;EA2CE;IACC,yCAAA;EAzCH;EA2CG;IACC,gBAAA;IACA,cAAA;IACA,yBAAA;IACA,sBAAA;IACA,WAAA;IACA,WAAA;IACA,cAAA;EAzCJ;EA2CI;IACC,eAAA;IACA,cAAA;IACA,qBAAA;IACA,oCAAA;IACA,iBAAA;EAzCL;EA4CI;IACC,kBAAA;EA1CL;AACF","sourcesContent":[".blueanchor{\r\n    cursor:pointer;text-decoration:underline;color:#3bb1ff;\r\n}\r\n\r\n:host ::ng-deep {\r\n\t.p-paginator {\r\n\t\t.p-paginator-current {\r\n\t\t\tmargin-left: auto;\r\n\t\t}\r\n\t}\r\n\r\n\t.p-progressbar {\r\n\t\theight: .5rem;\r\n\t\tbackground-color: #D8DADC;\r\n\r\n\t\t.p-progressbar-value {\r\n\t\t\tbackground-color: #607D8B;\r\n\t\t}\r\n\t}\r\n\r\n\t.table-header {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t}\r\n\r\n\t.p-calendar .p-datepicker {\r\n\t\tmin-width: 25rem;\r\n\r\n\t\ttd {\r\n\t\t\tfont-weight: 400;\r\n\t\t}\r\n\t}\r\n\r\n\t.p-datatable.p-datatable-customers {\r\n\t\t.p-datatable-header {\r\n\t\t\tpadding: 1rem;\r\n\t\t\ttext-align: left;\r\n\t\t\tfont-size: 1.5rem;\r\n\t\t}\r\n\r\n\t\t.p-paginator {\r\n\t\t\tpadding: 1rem;\r\n\t\t}\r\n\r\n\t\t.p-datatable-thead > tr > th {\r\n\t\t\ttext-align: left;\r\n\t\t}\r\n\r\n\t\t.p-dropdown-label:not(.p-placeholder) {\r\n\t\t\ttext-transform: uppercase;\r\n\t\t}\r\n\t}\r\n\r\n\t.p-datatable.p-datatable-customers:not(.p-datatable-gridlines) {\r\n\t\t.p-datatable-tbody > tr > td {\r\n\t\t\tcursor: auto;\r\n\t\t}\r\n\t}\r\n\r\n\t/* Responsive */\r\n\t.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {\r\n\t\tdisplay: none;\r\n\t}\r\n}\r\n\r\n.customer-badge {\r\n\tborder-radius: 2px;\r\n\tpadding: .25em .5rem;\r\n\ttext-transform: uppercase;\r\n\tfont-weight: 700;\r\n\tfont-size: 12px;\r\n\tletter-spacing: .3px;\r\n\r\n\t&.status-qualified {\r\n\t\tbackground: #C8E6C9;\r\n\t\tcolor: #256029;\r\n\t}\r\n\r\n\t&.status-unqualified {\r\n\t\tbackground: #FFCDD2;\r\n\t\tcolor: #C63737;\r\n\t}\r\n\r\n\t&.status-negotiation {\r\n\t\tbackground: #FEEDAF;\r\n\t\tcolor: #8A5340;\r\n\t}\r\n\r\n\t&.status-new {\r\n\t\tbackground: #B3E5FC;\r\n\t\tcolor: #23547B;\r\n\t}\r\n\r\n\t&.status-renewal {\r\n\t\tbackground: #ECCFFF;\r\n\t\tcolor: #694382;\r\n\t}\r\n\r\n\t&.status-proposal {\r\n\t\tbackground: #FFD8B2;\r\n\t\tcolor: #805B36;\r\n\t}\r\n}\r\n\r\n.product-badge {\r\n\tborder-radius: 2px;\r\n\tpadding: .25em .5rem;\r\n\ttext-transform: uppercase;\r\n\tfont-weight: 700;\r\n\tfont-size: 12px;\r\n\tletter-spacing: .3px;\r\n\r\n\t&.status-instock {\r\n\t\tbackground: #C8E6C9;\r\n\t\tcolor: #256029;\r\n\t}\r\n\r\n\t&.status-outofstock {\r\n\t\tbackground: #FFCDD2;\r\n\t\tcolor: #C63737;\r\n\t}\r\n\r\n\t&.status-lowstock {\r\n\t\tbackground: #FEEDAF;\r\n\t\tcolor: #8A5340;\r\n\t}\r\n}\r\n\r\n.order-badge {\r\n\tborder-radius: 2px;\r\n\tpadding: .25em .5rem;\r\n\ttext-transform: uppercase;\r\n\tfont-weight: 700;\r\n\tfont-size: 12px;\r\n\tletter-spacing: .3px;\r\n\r\n\t&.order-delivered {\r\n\t\tbackground: #C8E6C9;\r\n\t\tcolor: #256029;\r\n\t}\r\n\r\n\t&.order-cancelled {\r\n\t\tbackground: #FFCDD2;\r\n\t\tcolor: #C63737;\r\n\t}\r\n\r\n\t&.order-pending {\r\n\t\tbackground: #FEEDAF;\r\n\t\tcolor: #8A5340;\r\n\t}\r\n\r\n\t&.order-returned {\r\n\t\tbackground: #ECCFFF;\r\n\t\tcolor: #694382;\r\n\t}\r\n}\r\n\r\n.filterresetbuttons{\r\n\t\t\r\n}\r\n.downloadbuttons{\r\n\r\n}\r\n.buttonswrapper{\r\n\tdisplay:flex;\r\n\tjustify-content: space-between;\r\n\t\r\n}\r\n.mobilesearch{\r\n\tdisplay:none;\r\n}\r\n\r\n.eurocodewidth{\r\n\twidth:11rem;\r\n}\r\n\r\n.oewidth{\r\n\twidth:7rem;\r\n}\r\n\r\n@media screen and (max-width: 960px) {\r\n\t.buttonswrapper{\r\n\t\tdisplay:flex;\r\n\t\tflex-direction: column;\r\n\t\tgap:10px;\r\n\t}\r\n\t.mobilesearch{\r\n\t\tdisplay:flex;\r\n\t\tflex-direction: column;\r\n\t\tgap:10px;\r\n\t\tmargin-bottom:10px;\r\n\t\t.mobile-width-100{\r\n\t\t\twidth:100%;\r\n\t\t}\r\n\t\t.eurocodewidth{\r\n\t\t\twidth:100%;\r\n\t\t}\r\n\t\t\r\n\t\t.oewidth{\r\n\t\t\twidth:100%;\r\n\t\t}\r\n\t\r\n\t}\r\n\r\n\r\n\t:host ::ng-deep {\r\n\t\t.p-datatable {\r\n\t\t\t&.p-datatable-customers {\r\n\t\t\t\t.p-datatable-thead > tr > th,\r\n\t\t\t\t.p-datatable-tfoot > tr > td {\r\n\t\t\t\t\tdisplay: none !important;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.p-datatable-tbody > tr {\r\n\t\t\t\t\tborder-bottom: 1px solid var(--surface-d);\r\n\r\n\t\t\t\t\t> td {\r\n\t\t\t\t\t\ttext-align: left;\r\n\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t\tborder: 0 none !important;\r\n\t\t\t\t\t\twidth: 100% !important;\r\n\t\t\t\t\t\tfloat: left;\r\n\t\t\t\t\t\tclear: left;\r\n\t\t\t\t\t\tborder: 0 none;\r\n\r\n\t\t\t\t\t\t.p-column-title {\r\n\t\t\t\t\t\t\tpadding: .4rem;\r\n\t\t\t\t\t\t\tmin-width: 30%;\r\n\t\t\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t\t\t\tmargin: -.4rem 1rem -.4rem -.4rem;\r\n\t\t\t\t\t\t\tfont-weight: bold;\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t.p-progressbar {\r\n\t\t\t\t\t\t\tmargin-top: .5rem;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
